module.exports = __webpack_public_path__ + "static/img/cjwt.bdf7aacf.jpg";